module.exports = __webpack_public_path__ + "static/media/thejessicalee.e532b49c.png";